import React, { FC, HTMLAttributes } from "react";

export interface AProps extends HTMLAttributes<HTMLAnchorElement> {
    openInNewTab?: boolean;
    title?: string;
    href?: string;
    className?: string;
    itemProp?: string;
}

const A: FC<AProps> = ({ openInNewTab, title, href, className, children, ...props }) => {
    return (
        <a
            href={href}
            target={openInNewTab ? "_blank" : undefined}
            rel="noopener noreferrer"
            title={title}
            className={className}
            {...props}
        >
            {children}
        </a>
    );
};

export default A;
